import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SmsCredits } from '@account-users/account/models/SmsCredits';
import { PatchSmsCreditsPayload } from '@account-users/account/models/PatchSmsCreditsPayload';

@Injectable({
  providedIn: 'root',
})
export class SmsCreditsService {
  constructor(
    private http: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  getSmsCredits(accountId: string) {
    return this.http.get(
      `${this.apiBaseUrl}accounts/${accountId}/smscredits`,
    ) as Observable<SmsCredits>;
  }

  patchSmsCredits({ accountId, addCredits, orderId }: PatchSmsCreditsPayload) {
    return this.http.patch(
      `${this.apiBaseUrl}accounts/${accountId}/smscredits?orderId=${orderId}`,
      { addCredits },
    ) as Observable<SmsCredits>;
  }
}
